/*
 * validation-rules.js - Validation rules for volunteer application approval form.
 *
 * @author Alex Symeonidis
 */

import * as yup from "yup";

/**
 * Volunteer application approval form validation schema.
 */
export const volunteerApplicationApprovalFormSchema = yup.object({

  lineOfEducationId: yup
    .string().required('line-of-education.required')
    .notOneOf(['00000000-0000-0000-0000-000000000000'], 'line-of-education.specified'),

  selfDescription: yup.string().required('self-description.required'),
  careerReasons: yup.string().required('career-reasons.required'),
  joiningReasons: yup.string().required('joining-reasons.required'),

});